import { GridCol, mixins, styled } from '@bob/library'
import { Link } from 'gatsby'

export const Title = styled.h1`
  ${mixins.typography.headlineXl}
`

export const ContentWrapper = styled(GridCol)`
  margin: 0 auto;
`

export const HeaderWrapper = styled.div`
  margin: 30px auto;
`

export const StepsWrapper = styled.div`
  margin-top: 50px;
  padding-bottom: 100px;
`

export const LinkButton = styled(Link)`
  &:hover {
    text-decoration: underline;
  }
`
